import _ from 'lodash';
import big from 'big.js';
import template from './diary.html';

export default {
  name: 'reportsDiary',
  template,
  controller: DiaryController,
  controllerAs: 'DiaryCtrl',
  bindings: {
    options: '<',
    defaultTableOptions: '<'
  }
};

/* @ngInject */
function DiaryController(
  NgTableParams,
  ReportsService,
  PrettyNamesConst,
  $q,
  ModalService
) {
  const vm = this;

  const maxSelectable = 10;
  let columnsSelected = 0;

  vm.$onInit = initialize;
  vm.prettyNames = PrettyNamesConst;
  vm.selectEquipment = selectEquipment;
  vm.generateTankDiaryReport = generateTankDiaryReport;
  vm.toggleSelectedDataKey = toggleSelectedDataKey;
  vm.getData = getData;
  vm.lengthOf = ReportsService.lengthOf;
  vm.deepLink = ReportsService.deepLink;
  vm.exportData = ReportsService.exportData;
  vm.openCopyReportLink = ModalService.openCopyReportLink;

  function initialize() {
    vm.isLoading = true;

    ReportsService.getFullListOfEquipment()
      .then((success) => {
        vm.options = angular.copy(vm.options);
        vm.options.equipment = success;
        vm.isLoading = false;
        if (vm.options.selectedEquipmentId !== '') {
          const equipmentId = vm.options.selectedEquipmentId;
          vm.options.selectedEquipment = _.find(success, ['id', equipmentId]);
          delete vm.options.selectedEquipmentId;
          if (vm.options.selectedEquipment) {
            vm.tableParams.reload();
          }
        }
      });

    vm.tableParams = new NgTableParams(vm.defaultTableOptions, {
      count: 0,
      getData
    });
  }

  function selectEquipment($index) {
    if (vm.options.equipment.length) {
      vm.options.selectedEquipment = vm.options.equipment[$index];
    }
  }

  function generateTankDiaryReport() {
    vm.tableParams.page(1);
    vm.tableParams.reload();
  }

  function toggleSelectedDataKey(dataKey) {
    vm.options.dataKeys[dataKey] = !vm.options.dataKeys[dataKey];
  }

  function getData($table) {
    const params = $table._params;
    if (vm.isLoading) {
      return null;
    }
    vm.isLoading = true;
    vm.enableExport = false;
    vm.options.dataKeys = null;
    columnsSelected = 0;
    if (vm.options.selectedEquipment) {
      let sortString = '';
      if ($table.sorting()) {
        const sortColumn = Object.keys($table.sorting())[0];
        const sortDirection = $table.sorting()[Object.keys($table.sorting())[0]];

        sortString = [sortColumn, sortDirection].join('|') || sortString;
      }

      return ReportsService.getEquipmentEventData(
        vm.options.selectedEquipment.id,
        vm.options.selectedEquipment.equipmentType,
        vm.options.date.start.valueOf(),
        vm.options.date.end.valueOf(),
        sortString,
        params.page,
        params.count
      )
        .then((success) => {
          vm.options.dataKeys = {};
          if (success.data && success.data.tankDatas) {
            const isTank = vm.options.selectedEquipment.equipmentType === 'tanks';
            for (let ii = 0, jj = success.data.tankDatas.length; ii < jj; ii++) {
              if (isTank) {
                const thisOne = success.data.tankDatas[ii].data;
                if (
                  _.every([thisOne.topLevel, thisOne.waterLevel, thisOne.correctionFactor, thisOne.inchesToBarrels],
                    _.isNumber)
                ) {
                  const top = big(thisOne.topLevel)
                    .add(thisOne.correctionFactor)
                    .times(thisOne.inchesToBarrels);
                  const water = big(thisOne.waterLevel)
                    .add(thisOne.correctionFactor)
                    .times(thisOne.inchesToBarrels);
                  const oil = big(top).minus(water);
                  const fixedVal = 2;
                  thisOne.topLevel = parseFloat(top).toFixed(fixedVal);
                  thisOne.oilLevel = parseFloat(oil).toFixed(fixedVal);
                  thisOne.waterLevel = parseFloat(water).toFixed(fixedVal);
                } else {
                  thisOne.topLevel = 'N/A';
                  thisOne.oilLevel = 'N/A';
                  thisOne.waterLevel = 'N/A';
                }
              }
              _.forEach(success.data.tankDatas[ii].data, updateDatakeysIncrementColumns);
            }
            $table.total(success.data.count);

            if (success.data.tankDatas.length) {
              vm.enableExport = true;
            }
            return success.data.tankDatas;
          }
          vm.isLoading = false;
          return $q.reject('nothing returned from server.');
        })
        .catch(error => $q.reject(`Error: ${error}`))
        .finally(() => {
          vm.isLoading = false;
        });
    }
    vm.isLoading = false;
    return $q.reject('Error: please select an equipment, start date, and end date.');
  }

  function updateDatakeysIncrementColumns(__, dataKey) {
    if (!_.has(vm.options.dataKeys, dataKey)) {
      vm.options.dataKeys[dataKey] = columnsSelected < maxSelectable;
      if (columnsSelected < maxSelectable) {
        columnsSelected += 1;
      }
    }
  }
}
